import {
  useState,
} from 'react';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  useNavigate,
} from 'react-router';

import {
  coreActions,
  coreSelectors,
  type Coupon,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  Spinner,
} from 'web-components';
import Checkout from 'web-components/IdeafitPayments/Checkout'

import {
  Flex,
} from 'web-styled';

import Item from '../Item';

const mapState = state => ({
  clientId: coreSelectors.getProfile('id')(state),
  products: coreSelectors.getResourceMappedList(
    'products',
  )(state),
  setPlanState: coreSelectors.getPaymentRequestsState(
    'setPlanState',
  )(state),
  productPlans: coreSelectors.getResourceMappedList(
    'productPlans',
  )(state),
  subscription: coreSelectors.getSubscription(state),
});

const ClientItems = () => {
  const [coupon, setCoupon] = useState<Coupon | null>(null);
  const [couponState, setCouponState] = useState<any>({ value: '' });
  const [selectedPlan, setSelectedPlan] = useState<any | null>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    clientId,
    products,
    setPlanState,
    subscription,
    productPlans,
  } = useSelector(mapState, shallowEqual);

  const onBuyProduct = (productId: number) => {
    const onSuccess = () => {
      dispatch(
        uiActions.setUiState({
          checkoutModal: {
            isOpen: true,
            type: 'buy',
          },
        }),
      );
    };

    dispatch(
      coreActions.requestBuyProduct({
        payload: {
          client_id: clientId,
          product_id: productId,
        },
        callbacks: {
          onSuccess,
        },
      }),
    );
  }

  const handleCheckCoupon = (coupon: string) => {
    setCouponState(s => ({
      ...s,
      loading: true,
    }))
    dispatch(
      coreActions.requestCheckCoupon({
        coupon,
        callbacks: {
          onSuccess: (res: Coupon) => {
            setCoupon(res)
            setCouponState(s => ({
              ...s,
              loading: false,
              status: 'valid',
            }))
          },
          onError: (res: Coupon) => {
            setCoupon(res)
            setCouponState(s => ({
              ...s,
              loading: false,
              status: 'invalid',
            }))
          },
        },
      }),
    );
  }

  return (
    <Flex
      column
      flex="0 0 1000px"
      spacing={30}
    >
      {(setPlanState === 'pending') && <Spinner over />}

      {productPlans.map((plan) => (
        <Item
          key={plan.id}
          name={plan.name}
          amount={plan.amount}
          currency={plan.currency}
          interval={plan.interval}
          imageUrl={plan.image?.url}
          videoUrl={plan.video_url}
          isSelected={plan.stripe_id === subscription.plan.id}
          description={plan.description}
          onSubscribe={() => {
            if (plan.stripe_id === subscription.plan.id) {
              navigate('/account/details');
              return;
            }

            setSelectedPlan(plan);
          }}
        />
      ))}

      {products.map((product) => (
        <Item
          key={product.id}
          name={product.name}
          amount={product.amount}
          currency={product.currency}
          imageUrl={product.image?.url}
          videoUrl={product.video_url}
          description={product.description}
          onBuy={() => onBuyProduct(product.id)}
        />
      ))}


      {selectedPlan?.id && (
        <Checkout
          coupon={coupon}
          couponState={couponState}
          plan={{
            id: selectedPlan.id,
            price: String(selectedPlan.amount),
            name: selectedPlan.name,
            interval: selectedPlan.interval,
          }}
          subscriptionId={subscription?.id}
          onCheckCoupon={handleCheckCoupon}
          onRequestClose={() => setSelectedPlan(null)}
        />
      )}
    </Flex>
  );
};

export default ClientItems;
